import { IDeleteInspecaoObraExecutadoPorUseCase } from "../../../presentation/useCases/delete/delete_inspecao_obra_executado_por_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteInspecaoObraExecutadoPorUseCase
 */

export class DeleteInspecaoObraExecutadoPorUseCase implements IDeleteInspecaoObraExecutadoPorUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteInspecaoObraExecutadoPor(
    idObra: number,
    idInspecaoObra: number,
    idExecutadoPor: number,
  ): Promise<void> {
    await this.repository.deleteInspecaoObraExecutadoPor(
      idObra,
      idInspecaoObra,
      idExecutadoPor,
    );
  }
}
